import { useLayoutEffect } from 'react';
/**
 * A React component that succeeds the desired experience when mounted. Uses useLayoutEffect to ensure accuracy of success measurement
 * Use this instead of a straight call to `experience.success()` if your success point is during a render.
 * @param experience
 * @constructor
 */
export var ExperienceSuccess = function ExperienceSuccess(_ref) {
  var experience = _ref.experience;
  useLayoutEffect(function () {
    experience.success();
  }, [experience]);
  return null;
};